import { toast } from 'react-toastify';

import { getSerializedErrorMessage } from '../../../../../utils/errors';

import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import type { IEducation } from '../../../../../pages/common';
import type { IntakeQuestionnaireState } from '../../types';
import type { IntakeEducationThunks, SetIntakeNotAttendingSchoolPayload } from './types';

export function addIntakeEducationCases(
  builder: ActionReducerMapBuilder<IntakeQuestionnaireState>,
  thunks: IntakeEducationThunks,
) {
  addUpdateIntakeEducationInfoCases(builder, thunks);
  addSetIntakeNotAttendingSchoolCases(builder, thunks);
}

function addUpdateIntakeEducationInfoCases(
  builder: ActionReducerMapBuilder<IntakeQuestionnaireState>,
  thunks: IntakeEducationThunks,
) {
  const { updateIntakeEducationInfo } = thunks;

  builder
    .addCase(updateIntakeEducationInfo.pending, (state) => {
      state.updateEducationInfoLoading = true;
      state.error = null;
    })
    .addCase(
      updateIntakeEducationInfo.fulfilled,
      (state, action: PayloadAction<IEducation>) => {
        state.updateEducationInfoLoading = false;
        if (!state.intakeQuestionnaireDetails) return;
        state.intakeQuestionnaireDetails.education_info = action.payload;
        // The backend clears not_attending_school whenever education info is patched.
        state.intakeQuestionnaireDetails.not_attending_school = false;
      },
    )
    .addCase(updateIntakeEducationInfo.rejected, (state, action) => {
      state.updateEducationInfoLoading = false;
      state.error = action.error;
      toast.error(getSerializedErrorMessage(action.error));
    });
}

function addSetIntakeNotAttendingSchoolCases(
  builder: ActionReducerMapBuilder<IntakeQuestionnaireState>,
  thunks: IntakeEducationThunks,
) {
  const { setIntakeNotAttendingSchool } = thunks;

  builder
    .addCase(setIntakeNotAttendingSchool.pending, (state) => {
      state.setNotAttendingSchoolLoading = true;
      state.error = null;
    })
    .addCase(
      setIntakeNotAttendingSchool.fulfilled,
      (state, action: PayloadAction<void, string, { arg: SetIntakeNotAttendingSchoolPayload }>) => {
        state.setNotAttendingSchoolLoading = false;
        if (!state.intakeQuestionnaireDetails) return;
        const { notAttendingSchool } = action.meta.arg;
        state.intakeQuestionnaireDetails.not_attending_school = notAttendingSchool;
        // The backend deletes the education info row when not_attending_school is set.
        if (notAttendingSchool) {
          state.intakeQuestionnaireDetails.education_info = null;
        }
      },
    )
    .addCase(setIntakeNotAttendingSchool.rejected, (state, action) => {
      state.setNotAttendingSchoolLoading = false;
      state.error = action.error;
      toast.error(getSerializedErrorMessage(action.error));
    });
}
